import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import marker from '../../../Assets/Images/MetodoEntrega/geo-alt-fill.svg'
import { useSelector } from 'react-redux'
import { validatorIsCountedCustomer } from 'Utils/functions'

export const AddressOption = ({
  address,
  selectAddress,
  optionSelected,
  showEditAddress,
  clienteAddresses,
}) => {
  const [show, setShow] = React.useState(false)

  const useSelectorQuoteObject = useSelector(state => state?.cotizacion)

  const isCountedCustomer = validatorIsCountedCustomer(
    useSelectorQuoteObject?.QuoteHeader
  )

  const addressStreet =
    address?.AddressInfo?.Street ||
    address?.AddressInfo?.AddressDetail ||
    address?.AddressInfo?.Address_Street ||
    address.AddressInfo?.Address_AddressDetail ||
    address?.AddressInfo?.QuoteAddressStreet

  const selectedAddressId =
    optionSelected?.AddressInfo?.AddressId ||
    optionSelected?.AddressInfo?.Address_AddressId ||
    optionSelected?.Address_AddressId

  const currentAddressId = address.AddressInfo?.AddressId

  const isSelectedDirection = !isCountedCustomer
    ? !!(
        selectedAddressId &&
        currentAddressId &&
        selectedAddressId.toLowerCase() === currentAddressId.toLowerCase()
      )
    : clienteAddresses?.length === 1

  const handleEditAddress = () => {
    showEditAddress(address?.AddressInfo)
  }

  const description =
    address.AddressInfo?.Name || address.AddressInfo?.Address_Street
  const alias =
    address.AddressInfo?.AddressDetail ||
    address.AddressInfo?.Address_AddressDetail
  const country =
    address.AddressInfo?.CountryId || address.AddressInfo?.Address_CountryId
  const province =
    address.AddressInfo?.ProvinceId || address.AddressInfo?.Address_ProvinceId
  const district =
    address.AddressInfo?.DistrictId || address.AddressInfo?.Address_DistrictId
  const township =
    address.AddressInfo?.TownshipId || address.AddressInfo?.Address_TownshipId

  const invalidAddress = isCountedCustomer
    ? false
    : !(description && alias && country && province && district && township)

  return (
    <>
      <div
        className="address-option-wrapper"
        data-testid="container-address-option">
        <div
          className="tooltip"
          data-testid="tooltip-address"
          style={show ? { visibility: 'visible' } : {}}
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}>
          {addressStreet}
          <button
            data-testid="btn-edit-address"
            onClick={handleEditAddress}
            className="address-edit-button">
            Editar
          </button>
        </div>
        <li
          data-testid={`li-address-item-${
            address?.AddressInfo?.AddressId || 'unknown'
          }`}
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
          className={
            isSelectedDirection && !invalidAddress
              ? 'domicilio-option selected'
              : 'domicilio-option'
          }
          style={{ position: 'relative' }}>
          <div className="name-domicilio" data-testid="container-address-name">
            <img src={marker} alt="marcador" />
            <label htmlFor={address?.AddressInfo?.AddressId}>
              {address.AddressInfo?.Name || addressStreet}
            </label>
          </div>
          <div data-testid="container-address-selection">
            <input
              type="radio"
              id={
                address?.AddressInfo?.AddressId ||
                address?.AddressInfo?.Address_AddressId
              }
              name="selected-address"
              checked={isSelectedDirection}
              onChange={() => selectAddress(address, true)}
            />
            <FontAwesomeIcon icon={faCheck} />
          </div>
        </li>
      </div>
    </>
  )
}
